(function () {
  function initSupermarketFilters() {
    var supermarketSections = document.querySelectorAll('.tgd-supermarket');

    supermarketSections.forEach(function (section) {
      var filterButton = section.querySelector('.tgd-supermarket__filter-button');
      var filterDrawer = section.querySelector('.tgd-supermarket-filter');
      var closeButton = section.querySelector('.tgd-supermarket-filter__close');
      var overlay = section.querySelector('.tgd-supermarket-filter__overlay');
      var clearButton = section.querySelector('.tgd-supermarket-filter__clear');
      var viewButton = section.querySelector('.tgd-supermarket-filter__view');
      var filterOptions = section.querySelectorAll('.tgd-supermarket-filter-option');
      var filterGroups = section.querySelectorAll('.tgd-supermarket-filter__group');
      var productCards = section.querySelectorAll('.tgd-supermarket-card');
      var productCount = section.querySelector('.tgd-supermarket__count');
      var activeFiltersContainer = section.querySelector(
        '.tgd-supermarket__active-filters'
      );
      var dynamicPagination = section.querySelector(
        '.tgd-supermarket__dynamic-pagination'
      );
      var grid = section.querySelector('.tgd-supermarket__grid');
      var topPagination = section.querySelector(
        '.tgd-supermarket__top-pagination'
      );
      var liquidPagination = section.querySelector(
        '.tgd-supermarket-pagination'
      );
      var fullScreenLoader = section.querySelector(
        '.tgd-supermarket-loader'
      );
      var fullScreenLoaderLogo = section.querySelector(
        '.tgd-supermarket-loader__logo'
      );
      var premiumButton = section.querySelector('.tgd-supermarket__premium-button');
      var premiumActive = false;
      var sortButton = section.querySelector('.tgd-supermarket__sort-button');
      var sortDrawer = section.querySelector('.tgd-supermarket-sort');
      var sortCloseButton = section.querySelector('.tgd-supermarket-sort__close');
      var sortOverlay = section.querySelector('.tgd-supermarket-sort__overlay');
      var sortViewButton = section.querySelector('.tgd-supermarket-sort__view');
      var sortClearButton = section.querySelector('.tgd-supermarket-sort__clear');
      var sortOptions = section.querySelectorAll('[data-sort-value]');
      var selectedSort = 'recent';


      var endpoint =
        'https://fzywhxxtnzidklaewqul.supabase.co/functions/v1/supermarket-catalog-colors-preview';

      var pageSize = 48;

      if (!filterButton || !filterDrawer || !closeButton || !overlay) return;

      function prepareLoaderLogo() {
        if (!fullScreenLoaderLogo) return;
        if (fullScreenLoaderLogo.querySelector('img')) return;

        var headerLogo = document.querySelector(
          '[data-tgd-header-logo] img'
        );

        if (!headerLogo) return;

        var loaderLogo = headerLogo.cloneNode(true);

        loaderLogo.removeAttribute('id');
        loaderLogo.removeAttribute('class');
        loaderLogo.removeAttribute('loading');

        loaderLogo.setAttribute('aria-hidden', 'true');
        loaderLogo.alt = '';

        fullScreenLoaderLogo.appendChild(loaderLogo);
      }

      function showLoader() {
        if (!fullScreenLoader) return;

        prepareLoaderLogo();

        fullScreenLoader.classList.add('is-active');
        fullScreenLoader.setAttribute('aria-hidden', 'false');
      }

      function hideLoader() {
        if (!fullScreenLoader) return;

        fullScreenLoader.classList.remove('is-active');
        fullScreenLoader.setAttribute('aria-hidden', 'true');
      }

      function openFilterDrawer() {
        closeSortDrawer();
        filterDrawer.classList.add('is-open');
        filterDrawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      function closeFilterDrawer() {
        filterDrawer.classList.remove('is-open');
        filterDrawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      function openSortDrawer() {
        if (!sortDrawer) return;
        closeFilterDrawer();
        sortDrawer.classList.add('is-open');
        sortDrawer.setAttribute('aria-hidden', 'false');
        if (sortButton) sortButton.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      }

      function closeSortDrawer() {
        if (!sortDrawer) return;
        sortDrawer.classList.remove('is-open');
        sortDrawer.setAttribute('aria-hidden', 'true');
        if (sortButton) sortButton.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }

      function selectSort(value) {
        selectedSort = value === 'recent' ? value : 'recent';
        sortOptions.forEach(function (option) {
          var isActive = option.getAttribute('data-sort-value') === selectedSort;
          option.classList.toggle('is-active', isActive);
          option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function normalizeCategory(value) {
        return String(value || '').trim().toLowerCase();
      }

      function applyCategoryFilter(category) {
        var normalizedSelectedCategory = normalizeCategory(category);

        productCards.forEach(function (card) {
          var rawCategories = card.getAttribute('data-filter-categories') || '';
          var cardCategories = rawCategories
            .split(',')
            .map(normalizeCategory)
            .filter(Boolean);

          var shouldShow =
            normalizedSelectedCategory === 'all' ||
            cardCategories.indexOf(normalizedSelectedCategory) !== -1;

          card.style.display = shouldShow ? '' : 'none';
        });
      }

      function setActiveOption(selectedOption) {
        var filterGroup = selectedOption.closest(
          '.tgd-supermarket-filter__group'
        );

        if (!filterGroup) return;

        var groupOptions = filterGroup.querySelectorAll(
          '.tgd-supermarket-filter-option'
        );

        var isAllOption =
          selectedOption.getAttribute('data-filter-category') === 'all' ||
          selectedOption.getAttribute('data-filter-style') === 'all' ||
          selectedOption.getAttribute('data-filter-material') === 'all';

        if (isAllOption) {
          groupOptions.forEach(function (option) {
            option.classList.remove('is-active');
          });

          selectedOption.classList.add('is-active');
          updateAllFilterGroupCounts();
          return;
        }

        var allOption = filterGroup.querySelector(
          '.tgd-supermarket-filter-option[data-filter-category="all"], ' +
          '.tgd-supermarket-filter-option[data-filter-style="all"], ' +
          '.tgd-supermarket-filter-option[data-filter-material="all"]'
        );

        if (allOption) {
          allOption.classList.remove('is-active');
        }

        selectedOption.classList.toggle('is-active');

        var activeSpecificOptions = filterGroup.querySelectorAll(
          '.tgd-supermarket-filter-option.is-active'
        );

        if (activeSpecificOptions.length === 0 && allOption) {
          allOption.classList.add('is-active');
        }

        updateAllFilterGroupCounts();
      }

      function getActiveOption(groupName) {
        var filterGroup = section.querySelector(
          '.tgd-supermarket-filter__group[data-filter-group="' +
            groupName +
            '"]'
        );

        if (!filterGroup) return null;

        return filterGroup.querySelector(
          '.tgd-supermarket-filter-option.is-active'
        );
      }

      function getActiveOptions(groupName) {
        var filterGroup = section.querySelector(
          '.tgd-supermarket-filter__group[data-filter-group="' +
            groupName +
            '"]'
        );

        if (!filterGroup) return [];

        return Array.from(
          filterGroup.querySelectorAll(
            '.tgd-supermarket-filter-option.is-active'
          )
        );
      }

      function getSelectedCategory() {
        var activeOption = getActiveOption('product');

        return activeOption
          ? activeOption.getAttribute('data-filter-category') || 'all'
          : 'all';
      }

      function getSelectedStyle() {
        var activeOption = getActiveOption('style');

        return activeOption
          ? activeOption.getAttribute('data-filter-style') || 'all'
          : 'all';
      }

      function getSelectedMaterial() {
        var activeOption = getActiveOption('material');

        return activeOption
          ? activeOption.getAttribute('data-filter-material') || 'all'
          : 'all';
      }

      function getSelectedCategories() {
        return getActiveOptions('product')
          .map(function (option) {
            return option.getAttribute('data-filter-category');
          })
          .filter(function (value) {
            return value && value !== 'all';
          });
      }

      function getSelectedStyles() {
        return getActiveOptions('style')
          .map(function (option) {
            return option.getAttribute('data-filter-style');
          })
          .filter(function (value) {
            return value && value !== 'all';
          });
      }

      function getSelectedMaterials() {
        return getActiveOptions('material')
          .map(function (option) {
            return option.getAttribute('data-filter-material');
          })
          .filter(function (value) {
            return value && value !== 'all';
          });
      }

      function updateQuickFilterIntro() {
        var intro = section.querySelector(
          '[data-tgd-quick-filter-intro]'
        );

        var introTitle = section.querySelector(
          '[data-tgd-quick-filter-intro-title]'
        );

        var introText = section.querySelector(
          '[data-tgd-quick-filter-intro-text]'
        );

        if (!intro || !introTitle || !introText) return;

        var selectedCategories = getSelectedCategories();

        if (selectedCategories.length !== 1) {
          intro.hidden = true;
          introTitle.textContent = '';
          introText.textContent = '';
          return;
        }

        var category = selectedCategories[0];

        var contentByCategory = {
          'Camisetas & Tops': {
            title: 'T-Shirts & Tops',
            text:
              'Customizable T-shirts and tops across different fits, weights and materials.'
          },
          'Sudaderas': {
            title: 'Sweatshirts',
            text:
              'Customizable sweatshirts and hoodies for everyday, streetwear and branded projects.'
          },
          'Pantalones': {
            title: 'Pants',
            text:
              'Customizable pants across casual, workwear and performance-focused styles.'
          },
          'Chaquetas & Abrigos': {
            title: 'Jackets & Coats',
            text:
              'Outer layers for customization, from lightweight jackets to heavier seasonal pieces.'
          },
          'Headwear': {
            title: 'Headwear',
            text:
              'Caps, beanies and other customizable headwear options for different projects.'
          },
          'Bolsas & Mochilas': {
            title: 'Bags & Backpacks',
            text:
              'Customizable bags and backpacks for retail, work, events and branded merchandise.'
          },
          'Accesorios': {
            title: 'Accessories',
            text:
              'Customizable accessories and complementary products for different uses and projects.'
          }
        };

        var content = contentByCategory[category];

        if (!content) {
          intro.hidden = true;
          introTitle.textContent = '';
          introText.textContent = '';
          return;
        }

        introTitle.textContent = content.title;
        introText.textContent = content.text;
        intro.hidden = false;
      }

      function updateFilterGroupCount(filterGroup) {
        if (!filterGroup) return;

        var groupName = filterGroup.getAttribute(
          'data-filter-group'
        );

        var countBadge = filterGroup.querySelector(
          '.tgd-supermarket-filter__group-count'
        );

        if (!groupName || !countBadge) return;

        var selectedValues = [];

        if (groupName === 'product') {
          selectedValues = getSelectedCategories();
        }

        if (groupName === 'style') {
          selectedValues = getSelectedStyles();
        }

        if (groupName === 'material') {
          selectedValues = getSelectedMaterials();
        }

        var count = selectedValues.length;

        countBadge.textContent = String(count);
        countBadge.hidden = count === 0;
      }

      function updateAllFilterGroupCounts() {
        var hasSelectedFilters = false;

        filterGroups.forEach(function (filterGroup) {
          updateFilterGroupCount(filterGroup);

          var groupName = filterGroup.getAttribute(
            'data-filter-group'
          );

          if (
            groupName === 'product' &&
            getSelectedCategories().length > 0
          ) {
            hasSelectedFilters = true;
          }

          if (
            groupName === 'style' &&
            getSelectedStyles().length > 0
          ) {
            hasSelectedFilters = true;
          }

          if (
            groupName === 'material' &&
            getSelectedMaterials().length > 0
          ) {
            hasSelectedFilters = true;
          }
        });

        if (clearButton) {
          clearButton.classList.toggle(
            'is-active',
            hasSelectedFilters
          );
        }

        section
          .querySelectorAll('[data-tgd-quick-filter]')
          .forEach(function (quickFilterButton) {
            var filterGroup =
              quickFilterButton.getAttribute(
                'data-filter-group'
              );

            var filterValue =
              quickFilterButton.getAttribute(
                'data-filter-category'
              );

            var isActive = false;
            if (
              filterGroup === 'product' &&
              filterValue === 'all'
            ) {
              isActive =
                getSelectedCategories().length === 0;
            }

            if (
              filterGroup === 'product' &&
              filterValue !== 'all'
            ) {
              isActive = getSelectedCategories().indexOf(
                filterValue
              ) !== -1;
            }

            if (filterGroup === 'style') {
              isActive = getSelectedStyles().indexOf(
                filterValue
              ) !== -1;
            }

            quickFilterButton.classList.toggle(
              'is-active',
              isActive
            );
          });
        updateQuickFilterIntro();
      }

      function updateFilterUrl() {
        var selectedCategories = getSelectedCategories();
        var selectedStyles = getSelectedStyles();
        var selectedMaterials = getSelectedMaterials();
        var url = new URL(window.location.href);

        url.searchParams.delete('product');
        url.searchParams.delete('style');
        url.searchParams.delete('material');
        url.searchParams.delete('page');

        selectedCategories.forEach(function (category) {
          url.searchParams.append('product', category);
        });

        selectedStyles.forEach(function (style) {
          url.searchParams.append('style', style);
        });

        selectedMaterials.forEach(function (material) {
          url.searchParams.append('material', material);
        });

        url.searchParams.delete('provider');

        if (premiumActive) {
          url.searchParams.set(
            'premium',
            'true'
          );
        } else {
          url.searchParams.delete('premium');
        }

        url.searchParams.set('sort', selectedSort);

        window.history.pushState(
          {},
          '',
          url.toString()
        );
      }

      function getPageFromUrl() {
        var page = Number(
          new URL(window.location.href).searchParams.get('page') || 1
        );

        return Number.isFinite(page) && page >= 1
          ? Math.floor(page)
          : 1;
      }

      function goToPage(page) {
        var targetPage = Number(page);

        if (!Number.isFinite(targetPage) || targetPage < 1) return;

        targetPage = Math.floor(targetPage);

        var url = new URL(window.location.href);
        url.searchParams.set('page', String(targetPage));
        window.history.pushState({}, '', url.toString());

        loadProducts(targetPage);
      }

      function applyFiltersFromUrl() {
        var url = new URL(window.location.href);

        var productParams = url.searchParams.getAll('product');
        var styleParams = url.searchParams.getAll('style');
        var materialParams = url.searchParams.getAll('material');
        var providerParam = url.searchParams.get('provider');
        selectSort(url.searchParams.get('sort') || 'recent');

        var productGroup = section.querySelector(
          '.tgd-supermarket-filter__group[data-filter-group="product"]'
        );

        var styleGroup = section.querySelector(
          '.tgd-supermarket-filter__group[data-filter-group="style"]'
        );

        var materialGroup = section.querySelector(
          '.tgd-supermarket-filter__group[data-filter-group="material"]'
        );

        function restoreGroupSelections(
          filterGroup,
          values,
          dataAttribute
        ) {
          if (!filterGroup) return;

          var options = filterGroup.querySelectorAll(
            '.tgd-supermarket-filter-option'
          );

          options.forEach(function (option) {
            option.classList.remove('is-active');
          });

          if (values.length === 0) {
            var allOption = filterGroup.querySelector(
              '.tgd-supermarket-filter-option[' +
                dataAttribute +
                '="all"]'
            );

            if (allOption) {
              allOption.classList.add('is-active');
            }

            updateFilterGroupCount(filterGroup);
            return;
          }

          values.forEach(function (value) {
            var option = filterGroup.querySelector(
              '.tgd-supermarket-filter-option[' +
                dataAttribute +
                '="' +
                CSS.escape(value) +
                '"]'
            );

            if (option) {
              option.classList.add('is-active');
            }
          });

          var activeOptions = filterGroup.querySelectorAll(
            '.tgd-supermarket-filter-option.is-active'
          );

          if (activeOptions.length === 0) {
            var fallbackAllOption = filterGroup.querySelector(
              '.tgd-supermarket-filter-option[' +
                dataAttribute +
                '="all"]'
            );

            if (fallbackAllOption) {
              fallbackAllOption.classList.add('is-active');
            }
          }

          updateFilterGroupCount(filterGroup);
        }

        restoreGroupSelections(
          productGroup,
          productParams,
          'data-filter-category'
        );

        restoreGroupSelections(
          styleGroup,
          styleParams,
          'data-filter-style'
        );

        restoreGroupSelections(
          materialGroup,
          materialParams,
          'data-filter-material'
        );

        var premiumParam = url.searchParams.get('premium');

        premiumActive = premiumParam === 'true';

        if (premiumButton) {
          premiumButton.classList.toggle(
            'is-active',
            premiumActive
          );
        }

        updateAllFilterGroupCounts();
      }

      function renderActiveFilter(
        selectedCategories,
        selectedStyles,
        selectedMaterials
      ) {
        if (!activeFiltersContainer) return;

        activeFiltersContainer.innerHTML = '';

        function appendActiveFilter(option, groupName) {
          if (!option) return;

          var activeFilter = document.createElement('button');

          activeFilter.type = 'button';
          activeFilter.className =
            'tgd-supermarket__active-filter';

          activeFilter.textContent =
            option.textContent.trim() + ' ×';

          activeFilter.addEventListener('click', function () {
            var filterGroup = option.closest(
              '.tgd-supermarket-filter__group'
            );

            if (!filterGroup) return;

            option.classList.remove('is-active');

            var remainingActiveOptions =
              filterGroup.querySelectorAll(
                '.tgd-supermarket-filter-option.is-active'
              );

            if (remainingActiveOptions.length === 0) {
              var allOption = null;

              if (groupName === 'product') {
                allOption = filterGroup.querySelector(
                  '.tgd-supermarket-filter-option[data-filter-category="all"]'
                );
              }

              if (groupName === 'style') {
                allOption = filterGroup.querySelector(
                  '.tgd-supermarket-filter-option[data-filter-style="all"]'
                );
              }

              if (groupName === 'material') {
                allOption = filterGroup.querySelector(
                  '.tgd-supermarket-filter-option[data-filter-material="all"]'
                );
              }

              if (allOption) {
                allOption.classList.add('is-active');
              }
            }

            updateAllFilterGroupCounts();
            updateFilterUrl();
            loadProducts(1);
          });

          activeFiltersContainer.appendChild(activeFilter);
        }

        getActiveOptions('product').forEach(function (option) {
          var value = option.getAttribute(
            'data-filter-category'
          );

          if (value && value !== 'all') {
            appendActiveFilter(option, 'product');
          }
        });

        getActiveOptions('style').forEach(function (option) {
          var value = option.getAttribute(
            'data-filter-style'
          );

          if (value && value !== 'all') {
            appendActiveFilter(option, 'style');
          }
        });

        getActiveOptions('material').forEach(function (option) {
          var value = option.getAttribute(
            'data-filter-material'
          );

          if (value && value !== 'all') {
            appendActiveFilter(option, 'material');
          }
        });
      }

      function renderProductCard(product) {
        var card = document.createElement('a');
        card.className = 'tgd-supermarket-card';
        card.href = product.shopifyUrl || '#';

        var media = document.createElement('div');
        media.className = 'tgd-supermarket-card__media';

        if (
          Array.isArray(product.catalogBadges) &&
          product.catalogBadges.indexOf('premium') !== -1
        ) {
          var premiumBadge = document.createElement('span');
          premiumBadge.className =
            'tgd-supermarket-card__badge tgd-supermarket-card__badge--premium';
          premiumBadge.textContent = 'Premium';

          media.appendChild(premiumBadge);
        }

        if (product.cardImageUrl) {
          var image = document.createElement('img');
          image.src = product.cardImageUrl;
          image.loading = 'lazy';
          image.className =
            'tgd-supermarket-card__image tgd-supermarket-card__image--fill-frame';
          image.alt = product.name || product.tgdProductRef || '';

          media.appendChild(image);
        }

        var info = document.createElement('div');
        info.className = 'tgd-supermarket-card__info';
        info.style.display = 'grid';
        info.style.gridTemplateColumns = '1fr auto';
        info.style.gap = '10px';
        info.style.alignItems = 'start';

        var mainInfo = document.createElement('div');

        var title = document.createElement('p');
        title.className = 'tgd-supermarket-card__title';
        title.textContent = product.name || product.tgdProductRef || '';
        mainInfo.appendChild(title);

        var ref = document.createElement('p');
        ref.className = 'tgd-supermarket-card__meta';
        ref.textContent = 'REF: ' + (product.tgdProductRef || '');
        mainInfo.appendChild(ref);

        var sizes = Array.isArray(product.availableSizes)
          ? product.availableSizes
          : [];

        if (sizes.length) {
          var sizesText = sizes.join(', ');

          if (
            sizes.indexOf('XXS') !== -1 &&
            sizes.indexOf('5XL') !== -1
          ) {
            sizesText = 'XXS–5XL';
          } else if (
            sizes.indexOf('XS') !== -1 &&
            sizes.indexOf('XXL') !== -1
          ) {
            sizesText = 'XS–XXL';
          } else if (
            sizes.indexOf('S') !== -1 &&
            sizes.indexOf('XL') !== -1
          ) {
            sizesText = 'S–XL';
          } else if (
            sizes.indexOf('OS') !== -1 ||
            sizes.indexOf('One Size') !== -1 ||
            sizes.indexOf('ONE SIZE') !== -1 ||
            sizes.indexOf('Talla única') !== -1
          ) {
            sizesText = 'ONE SIZE';
          }

          var sizesMeta = document.createElement('p');
          sizesMeta.className = 'tgd-supermarket-card__meta';
          sizesMeta.textContent = sizesText;
          mainInfo.appendChild(sizesMeta);
        }

        if (product.cardInfo) {
          var cardInfo = document.createElement('p');
          cardInfo.className = 'tgd-supermarket-card__meta';
          cardInfo.textContent = product.cardInfo;
          mainInfo.appendChild(cardInfo);
        }

        // TGD - Preview de colores en Supermarket
        var validHex = function (value) {
          return typeof value === 'string' &&
            /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i.test(value.trim());
        };

        var colors = (
          Array.isArray(product.availableColors)
            ? product.availableColors
            : []
        ).filter(function (color) {
          if (!color) return false;

          var pair = (color.compositeHexColor || '').split('/');

          return validHex(color.hexColor) ||
            (pair.length === 2 && pair.every(validHex)) ||
            /^https:\/\//i.test(color.swatchImageUrl || '');
        });

        if (colors.length) {
          var palette = document.createElement('div');
          palette.className = 'tgd-supermarket-card__colors';
          palette.style.visibility = 'hidden';

          var circles = colors.map(function (color) {
            var ring = document.createElement('span');
            ring.className = 'tgd-supermarket-card__color-ring';
            ring.title = color.name || 'Color';

            var fill = document.createElement('span');
            fill.className = 'tgd-supermarket-card__color-fill';

            var pair = (color.compositeHexColor || '').split('/');

            if (pair.length === 2 && pair.every(validHex)) {
              fill.style.background =
                'linear-gradient(135deg, ' +
                pair[0] + ' 50%, ' +
                pair[1] + ' 50%)';
            } else if (validHex(color.hexColor)) {
              fill.style.backgroundColor = color.hexColor;
            } else {
              fill.style.backgroundImage =
                'url(' +
                JSON.stringify(color.swatchImageUrl) +
                ')';
            }

            ring.appendChild(fill);
            palette.appendChild(ring);

            return ring;
          });

          var more = document.createElement('span');
          more.className = 'tgd-supermarket-card__colors-more';
          palette.appendChild(more);
          mainInfo.appendChild(palette);

          var total = Math.max(
            colors.length,
            Number(product.availableColorCount) || 0
          );

          function fitColors() {
            if (!palette.isConnected) return;

            var limit =
              palette.parentElement.getBoundingClientRect().width / 2;

            if (limit <= 0) return;

            var shown = circles.length;

            while (shown > 0) {
              var remaining = total - shown;

              more.textContent = '+' + remaining;
              more.style.display =
                remaining > 0 ? 'inline-block' : 'none';

              var used =
                shown * 20 +
                Math.max(0, shown - 1) * 4 +
                (
                  remaining > 0
                    ? 4 + more.getBoundingClientRect().width
                    : 0
                );

              if (used <= limit) break;

              shown--;
            }

            circles.forEach(function (circle, index) {
              circle.style.display =
                index < shown ? 'grid' : 'none';
            });

            var hidden = total - shown;

            more.textContent = '+' + hidden;
            more.style.display =
              hidden > 0 ? 'inline-block' : 'none';

            palette.style.visibility = '';
          }

          palette.tgdFitColors = fitColors;

          requestAnimationFrame(fitColors);

          if (!section.tgdColorsResizeBound) {
            section.tgdColorsResizeBound = true;

            window.addEventListener('resize', function () {
              section.querySelectorAll(
                '.tgd-supermarket-card__colors'
              ).forEach(function (row) {
                if (row.tgdFitColors) {
                  row.tgdFitColors();
                }
              });
            });
          }
        }

        info.appendChild(mainInfo);
        card.appendChild(media);
        card.appendChild(info);

        return card;
      }

      function syncTopPagination(sourceElement, loadPage) {
        var currentTopPagination = section.querySelector(
          '.tgd-supermarket__top-pagination'
        );

        if (!currentTopPagination || !sourceElement) return;

        currentTopPagination.innerHTML = '';

        var sourcePagination = sourceElement.querySelector(
          '.tgd-main-search__top-pagination'
        );

        if (!sourcePagination) return;

        var clonedPagination = sourcePagination.cloneNode(true);

        currentTopPagination.appendChild(clonedPagination);

        if (typeof loadPage !== 'function') return;

        var pageButtons = clonedPagination.querySelectorAll(
          '.pagination__item'
        );

        pageButtons.forEach(function (button) {
          if (button.disabled) return;
          if (button.tagName !== 'BUTTON') return;

          var ariaLabel = button.getAttribute('aria-label') || '';
          var pageNumber = null;

          if (ariaLabel.indexOf('Page ') === 0) {
            pageNumber = Number(
              ariaLabel.replace('Page ', '')
            );
          }

          if (ariaLabel === 'Previous page') {
            var paginationState = clonedPagination.querySelector(
              '.tgd-search-pagination'
            );

            var currentPage = Number(
              paginationState
                ? paginationState.getAttribute('data-page') || 1
                : 1
            );

            pageNumber = currentPage - 1;
          }

          if (ariaLabel === 'Next page') {
            var paginationStateNext = clonedPagination.querySelector(
              '.tgd-search-pagination'
            );

            var currentPageNext = Number(
              paginationStateNext
                ? paginationStateNext.getAttribute('data-page') || 1
                : 1
            );

            pageNumber = currentPageNext + 1;
          }

          if (!pageNumber || pageNumber < 1) return;

          button.addEventListener('click', function () {
            loadPage(pageNumber);
          });
        });

        var jumpForm = clonedPagination.querySelector(
          '.tgd-main-search__page-jump'
        );

        if (jumpForm) {
          jumpForm.addEventListener('submit', function (event) {
            event.preventDefault();

            var jumpSelect = jumpForm.querySelector('select');

            if (!jumpSelect) return;

            loadPage(Number(jumpSelect.value));
          });
        }
      }

      function renderDynamicPagination(data, loadPage) {
        if (!dynamicPagination) return;

        var currentPage = Number(data.page || 1);
        var totalPages = Number(data.totalPages || 1);

        dynamicPagination.innerHTML = '';

        if (totalPages <= 1) {
          dynamicPagination.hidden = true;

          if (topPagination) {
            topPagination.innerHTML = '';
          }

          return;
        }

        dynamicPagination.hidden = false;

        var wrapper = document.createElement('div');
        wrapper.className = 'tgd-main-search__top-pagination';

        var paginationMain = document.createElement('div');
        paginationMain.className = 'tgd-main-search__pagination-main';

        var paginationWrapper = document.createElement('div');
        paginationWrapper.className =
          'pagination-wrapper tgd-search-pagination';
        paginationWrapper.setAttribute('data-page', String(currentPage));

        var nav = document.createElement('nav');
        nav.className = 'pagination';
        nav.setAttribute('role', 'navigation');
        nav.setAttribute('aria-label', 'Pagination');

        var list = document.createElement('ul');
        list.className = 'pagination__list list-unstyled';
        list.setAttribute('role', 'list');

        function addPageButton(pageNumber, label, className) {
          var item = document.createElement('li');
          var button = document.createElement('button');

          button.type = 'button';
          button.className = className || 'pagination__item link';
          button.textContent = label || String(pageNumber);

          if (label === '←') {
            button.setAttribute('aria-label', 'Previous page');
          } else if (label === '→') {
            button.setAttribute('aria-label', 'Next page');
          } else {
            button.setAttribute('aria-label', 'Page ' + pageNumber);
          }

          if (
            pageNumber === currentPage &&
            label !== '←' &&
            label !== '→'
          ) {
            button.classList.add('pagination__item--current', 'light');
            button.setAttribute('aria-current', 'page');
            button.disabled = true;
          } else {
            button.addEventListener('click', function () {
              loadPage(pageNumber);
            });
          }

          item.appendChild(button);
          list.appendChild(item);
        }

        function addEllipsis() {
          var item = document.createElement('li');
          var span = document.createElement('span');

          span.className = 'pagination__item';
          span.textContent = '…';
          span.setAttribute('aria-hidden', 'true');

          item.appendChild(span);
          list.appendChild(item);
        }

        if (currentPage > 1) {
          addPageButton(
            currentPage - 1,
            '←',
            'pagination__item pagination__item--next pagination__item-arrow'
          );
        }

        var startPage = Math.max(1, currentPage - 4);
        var endPage = Math.min(totalPages, currentPage + 4);

        if (startPage > 1) {
          addPageButton(1, '1');

          if (startPage > 2) {
            addEllipsis();
          }
        }

        for (var page = startPage; page <= endPage; page += 1) {
          addPageButton(page, String(page));
        }

        if (endPage < totalPages) {
          if (endPage < totalPages - 1) {
            addEllipsis();
          }

          addPageButton(totalPages, String(totalPages));
        }

        if (currentPage < totalPages) {
          addPageButton(
            currentPage + 1,
            '→',
            'pagination__item pagination__item--prev pagination__item-arrow'
          );
        }

        nav.appendChild(list);

        paginationWrapper.classList.add(
          'tgd-search-pagination__desktop'
        );

        paginationWrapper.appendChild(nav);
        paginationMain.appendChild(paginationWrapper);

        var mobileNav = document.createElement('nav');
        mobileNav.className =
          'pagination tgd-supermarket-pagination-mobile';
        mobileNav.setAttribute('role', 'navigation');
        mobileNav.setAttribute('aria-label', 'Pagination');

        var mobileViewport = document.createElement('div');
        mobileViewport.className =
          'tgd-supermarket-pagination-mobile__viewport';

        var mobileList = document.createElement('ul');
        mobileList.className =
          'pagination__list list-unstyled tgd-supermarket-pagination-mobile__list';
        mobileList.setAttribute('role', 'list');
        mobileList.setAttribute('data-tgd-mobile-pagination', '');

        if (currentPage > 1) {
          var previousItem = document.createElement('li');
          previousItem.className =
            'tgd-supermarket-pagination-mobile__item';

          var previousButton = document.createElement('button');
          previousButton.type = 'button';
          previousButton.className =
            'pagination__item pagination__item-arrow link motion-reduce';
          previousButton.setAttribute('aria-label', 'Previous page');
          previousButton.textContent = '←';

          previousButton.addEventListener('click', function () {
            loadPage(currentPage - 1);
          });

          previousItem.appendChild(previousButton);
          mobileList.appendChild(previousItem);
        }

        for (
          var mobilePageNumber = 1;
          mobilePageNumber <= totalPages;
          mobilePageNumber += 1
        ) {
          var mobileItem = document.createElement('li');
          mobileItem.className =
            'tgd-supermarket-pagination-mobile__item';

          var mobileButton = document.createElement('button');
          mobileButton.type = 'button';
          mobileButton.className = 'pagination__item link';
          mobileButton.textContent = String(mobilePageNumber);
          mobileButton.setAttribute(
            'aria-label',
            'Page ' + mobilePageNumber
          );

          if (mobilePageNumber === currentPage) {
            mobileButton.classList.add(
              'pagination__item--current',
              'light'
            );
            mobileButton.setAttribute('aria-current', 'page');
            mobileButton.setAttribute('data-tgd-current-page', '');
            mobileButton.disabled = true;
          } else {
            (function (pageNumber) {
              mobileButton.addEventListener('click', function () {
                loadPage(pageNumber);
              });
            })(mobilePageNumber);
          }

          mobileItem.appendChild(mobileButton);
          mobileList.appendChild(mobileItem);
        }

        if (currentPage < totalPages) {
          var nextItem = document.createElement('li');
          nextItem.className =
            'tgd-supermarket-pagination-mobile__item';

          var nextButton = document.createElement('button');
          nextButton.type = 'button';
          nextButton.className =
            'pagination__item pagination__item-arrow link motion-reduce';
          nextButton.setAttribute('aria-label', 'Next page');
          nextButton.textContent = '→';

          nextButton.addEventListener('click', function () {
            loadPage(currentPage + 1);
          });

          nextItem.appendChild(nextButton);
          mobileList.appendChild(nextItem);
        }

        mobileViewport.appendChild(mobileList);
        mobileNav.appendChild(mobileViewport);
        paginationMain.appendChild(mobileNav);

        wrapper.appendChild(paginationMain);

        var jumpForm = document.createElement('form');
        jumpForm.className = 'tgd-main-search__page-jump';

        var jumpLabel = document.createElement('label');
        jumpLabel.className = 'tgd-main-search__page-jump-label';
        jumpLabel.textContent = 'GO TO PAGE:';

        var jumpSelectWrapper = document.createElement('div');
        jumpSelectWrapper.className = 'tgd-main-search__page-jump-select';

        var jumpSelect = document.createElement('select');
        jumpSelect.setAttribute('aria-label', 'Go to page');

        for (
          var optionPage = 1;
          optionPage <= totalPages;
          optionPage += 1
        ) {
          var option = document.createElement('option');
          option.value = String(optionPage);
          option.textContent = String(optionPage);

          if (optionPage === currentPage) {
            option.selected = true;
          }

          jumpSelect.appendChild(option);
        }

        var chevron = document.createElement('span');
        chevron.setAttribute('aria-hidden', 'true');
        chevron.textContent = '⌄';

        jumpSelectWrapper.appendChild(jumpSelect);
        jumpSelectWrapper.appendChild(chevron);

        var goButton = document.createElement('button');
        goButton.type = 'submit';
        goButton.className = 'tgd-main-search__page-jump-button';
        goButton.textContent = 'GO';

        jumpForm.appendChild(jumpLabel);
        jumpForm.appendChild(jumpSelectWrapper);
        jumpForm.appendChild(goButton);

        jumpForm.addEventListener('submit', function (event) {
          event.preventDefault();
          loadPage(Number(jumpSelect.value));
        });

        wrapper.appendChild(jumpForm);
        dynamicPagination.appendChild(wrapper);

        syncTopPagination(dynamicPagination, loadPage);
      }

      var latestLoadRequestId = 0;


      // TGD - Progressive color loading
      var colorsController = null;

      async function loadColorsProgressively(products, requestId) {
        if (!grid || !products || !products.length) return;

        var ids = products
          .map(function (product) {
            return product.productId;
          })
          .filter(Boolean);

        if (!ids.length) return;

        var url = new URL(
          'https://fzywhxxtnzidklaewqul.supabase.co/functions/v1/supermarket-colors-batch-preview'
        );

        ids.forEach(function (id) {
          url.searchParams.append('id', id);
        });

        var controller = new AbortController();
        colorsController = controller;

        var timeout = setTimeout(function () {
          controller.abort();
        }, 12000);

        try {
          var response = await fetch(url.toString(), {
            signal: controller.signal
          });

          if (!response.ok) {
            throw new Error('Colors API: ' + response.status);
          }

          var data = await response.json();

          if (
            controller.signal.aborted ||
            requestId !== latestLoadRequestId
          ) return;

          var colorsById = new Map(
            (data.products || []).map(function (item) {
              return [String(item.productId), item];
            })
          );

          var cards = grid.querySelectorAll(
            '.tgd-supermarket-card'
          );

          products.forEach(function (product, index) {
            var colorData = colorsById.get(
              String(product.productId)
            );

            if (!colorData || !colorData.availableColors?.length) {
              return;
            }

            var target = cards[index]?.querySelector(
              '.tgd-supermarket-card__info > div'
            );

            if (
              !target ||
              target.querySelector(
                '.tgd-supermarket-card__colors'
              )
            ) return;

            // Reuse the existing, validated swatch renderer.
            var temporaryCard = renderProductCard(
              Object.assign({}, product, colorData, {
                cardImageUrl: null,
                catalogBadges: []
              })
            );

            var palette = temporaryCard.querySelector(
              '.tgd-supermarket-card__colors'
            );

            if (!palette) return;

            target.appendChild(palette);

            requestAnimationFrame(function () {
              if (
                palette.isConnected &&
                typeof palette.tgdFitColors === 'function'
              ) {
                palette.tgdFitColors();
              }
            });
          });
        } catch (error) {
          if (!controller.signal.aborted) {
            console.warn(
              '[TGD Supermarket] Colors unavailable:',
              error
            );
          }
        } finally {
          clearTimeout(timeout);

          if (colorsController === controller) {
            colorsController = null;
          }
        }
      }


      async function loadProducts(page) {
        var requestId = ++latestLoadRequestId;
        if (colorsController) {
          colorsController.abort();
          colorsController = null;
        }

        showLoader();

        var selectedCategories = getSelectedCategories();
        var selectedStyles = getSelectedStyles();
        var selectedMaterials = getSelectedMaterials();
        var url = new URL(endpoint);

        url.searchParams.set('page', String(page || 1));
        url.searchParams.set('pageSize', String(pageSize));
        url.searchParams.set('sort', selectedSort);

        selectedCategories.forEach(function (category) {
          url.searchParams.append('product', category);
        });

        selectedStyles.forEach(function (style) {
          url.searchParams.append('style', style);
        });

        selectedMaterials.forEach(function (material) {
          url.searchParams.append('material', material);
        });

        if (premiumActive) {
          url.searchParams.set('premium', 'true');
        }

        try {
          console.log(
            '[TGD Supermarket] Request:',
            url.toString()
          );

          var response = await fetch(url.toString());

          if (requestId !== latestLoadRequestId) {
            return null;
          }

          if (!response.ok) {
            throw new Error(
              'Supermarket API error: ' +
                response.status +
                ' ' +
                response.statusText
            );
          }

          var data = await response.json();

          if (requestId !== latestLoadRequestId) {
            return null;
          }

          console.log(
            '[TGD Supermarket] Response:',
            data
          );

          if (!grid) {
            throw new Error(
              'Supermarket grid not found'
            );
          }

          if (productCount) {
            productCount.textContent =
              String(data.count || 0) + ' products';
          }

          renderActiveFilter(
            selectedCategories,
            selectedStyles,
            selectedMaterials
          );

          grid.innerHTML = '';

          if (
            !data.products ||
            data.products.length === 0
          ) {
            var emptyState =
              document.createElement('div');

            emptyState.className =
              'tgd-supermarket__empty-state';

            emptyState.innerHTML =
              '<p class="tgd-supermarket__empty-state-title">' +
              'No products found' +
              '</p>' +
              '<p class="tgd-supermarket__empty-state-text">' +
              'Try removing one or more filters.' +
              '</p>';

            grid.appendChild(emptyState);
          }


          (data.products || []).forEach(function (product) {
            grid.appendChild(
              renderProductCard(product)
            );
          });


          if (liquidPagination) {
            liquidPagination.style.display = 'none';
          }

          renderDynamicPagination(
            data,
            goToPage
          );

          var toolbar = section.querySelector(
            '.tgd-supermarket__toolbar'
          );

          if (toolbar) {
            toolbar.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }

          return data;
        } catch (error) {
          if (requestId === latestLoadRequestId) {
            console.error(
              '[TGD Supermarket] Error:',
              error
            );
          }

          return null;
        } finally {
          if (requestId === latestLoadRequestId) {
            hideLoader();
          }
        }
      }

      if (premiumButton) {
        premiumButton.addEventListener('click', function () {
          premiumActive = !premiumActive;

          premiumButton.classList.toggle(
            'is-active',
            premiumActive
          );

          updateFilterUrl();
          loadProducts(1);
        });
      }
      
      applyFiltersFromUrl();
      loadProducts(getPageFromUrl());

      window.addEventListener('popstate', function () {
        applyFiltersFromUrl();
        loadProducts(getPageFromUrl());
      });


      filterButton.addEventListener('click', openFilterDrawer);
      closeButton.addEventListener('click', closeFilterDrawer);
      overlay.addEventListener('click', closeFilterDrawer);

      if (sortButton) sortButton.addEventListener('click', openSortDrawer);
      if (sortCloseButton) sortCloseButton.addEventListener('click', closeSortDrawer);
      if (sortOverlay) sortOverlay.addEventListener('click', closeSortDrawer);

      sortOptions.forEach(function (option) {
        option.addEventListener('click', function () {
          selectSort(option.getAttribute('data-sort-value'));
        });
      });

      if (sortClearButton) {
        sortClearButton.addEventListener('click', function () {
          selectSort('recent');
        });
      }

      if (sortViewButton) {
        sortViewButton.addEventListener('click', function () {
          updateFilterUrl();
          closeSortDrawer();
          loadProducts(1);
        });
      }

      filterGroups.forEach(function (filterGroup) {
        var toggle = filterGroup.querySelector(
          '.tgd-supermarket-filter__group-toggle'
        );

        var content = filterGroup.querySelector(
          '.tgd-supermarket-filter__group-content'
        );

        if (!toggle || !content) return;

        toggle.addEventListener('click', function () {
          var isOpen =
            toggle.getAttribute('aria-expanded') === 'true';

          toggle.setAttribute(
            'aria-expanded',
            isOpen ? 'false' : 'true'
          );

          content.hidden = isOpen;

          filterGroup.classList.toggle(
            'is-open',
            !isOpen
          );
        });
      });

      filterOptions.forEach(function (option) {
        option.addEventListener('click', function () {
          setActiveOption(option);
        });
      });

      section
        .querySelectorAll('[data-tgd-quick-filter]')
        .forEach(function (quickFilterButton) {
          quickFilterButton.addEventListener('click', function () {
            var filterGroup =
              quickFilterButton.getAttribute(
                'data-filter-group'
              );

            var filterValue =
              quickFilterButton.getAttribute(
                'data-filter-category'
              );

            var allProductOption = section.querySelector(
              '.tgd-supermarket-filter-option[data-filter-category="all"]'
            );

            var allStyleOption = section.querySelector(
              '.tgd-supermarket-filter-option[data-filter-style="all"]'
            );

            var allMaterialOption = section.querySelector(
              '.tgd-supermarket-filter-option[data-filter-material="all"]'
            );

            if (allProductOption) {
              setActiveOption(allProductOption);
            }

            if (allStyleOption) {
              setActiveOption(allStyleOption);
            }

            if (allMaterialOption) {
              setActiveOption(allMaterialOption);
            }

            if (!filterGroup || !filterValue) return;

            var targetOption = null;

            if (filterGroup === 'product') {
              targetOption = Array.from(
                section.querySelectorAll(
                  '.tgd-supermarket-filter-option[data-filter-category]'
                )
              ).find(function (option) {
                return (
                  option.getAttribute(
                    'data-filter-category'
                  ) === filterValue
                );
              });
            }

            if (filterGroup === 'style') {
              targetOption = Array.from(
                section.querySelectorAll(
                  '.tgd-supermarket-filter-option[data-filter-style]'
                )
              ).find(function (option) {
                return (
                  option.getAttribute(
                    'data-filter-style'
                  ) === filterValue
                );
              });
            }

            if (!targetOption) return;

            setActiveOption(targetOption);
            updateFilterUrl();
            loadProducts(1);
          });
        });

      if (clearButton) {
        clearButton.addEventListener('click', function () {
          var allProductOption = section.querySelector(
            '.tgd-supermarket-filter-option[data-filter-category="all"]'
          );

          var allStyleOption = section.querySelector(
            '.tgd-supermarket-filter-option[data-filter-style="all"]'
          );

          var allMaterialOption = section.querySelector(
            '.tgd-supermarket-filter-option[data-filter-material="all"]'
          );

          if (allProductOption) {
            setActiveOption(allProductOption);
          }

          if (allStyleOption) {
            setActiveOption(allStyleOption);
          }

          if (allMaterialOption) {
            setActiveOption(allMaterialOption);
          }

          updateAllFilterGroupCounts();
          updateFilterUrl();
          loadProducts(1);
        });
      }

      if (viewButton) {
        viewButton.addEventListener('click', function () {
          updateFilterUrl();
          closeFilterDrawer();
          loadProducts(1);
        });
      }

      document.addEventListener('keydown', function (event) {
        if (
          event.key === 'Escape' &&
          filterDrawer.classList.contains('is-open')
        ) {
          closeFilterDrawer();
        }

        if (
          event.key === 'Escape' &&
          sortDrawer &&
          sortDrawer.classList.contains('is-open')
        ) {
          closeSortDrawer();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSupermarketFilters);
  } else {
    initSupermarketFilters();
  }
})();
